var _path, _path2, _rect, _path3, _rect2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNotifBellPl = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 15.6665C15.6521 14.3404 15.1024 13.0687 14.124 12.131C13.1455 11.1933 11.8185 10.6665 10.4347 10.6665C9.05099 10.6665 7.72393 11.1933 6.74548 12.131C5.76703 13.0687 5.21734 14.3404 5.21734 15.6665C5.21734 21.4998 2.60864 23.1665 2.60864 23.1665H18.2608C18.2608 23.1665 15.6521 21.4998 15.6521 15.6665Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9391 26.5C11.7862 26.7526 11.5667 26.9622 11.3027 27.1079C11.0387 27.2537 10.7394 27.3304 10.4347 27.3304C10.13 27.3304 9.8307 27.2537 9.56668 27.1079C9.30267 26.9622 9.08324 26.7526 8.93036 26.5",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#CD310A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 13.0994C19.1697 13.0994 20.2386 12.2401 20.2457 11.0611C20.2386 10.1449 19.5959 9.37429 18.7827 9.22869V9.18608C19.4893 9.01562 19.9688 8.35156 19.9759 7.56676C19.9688 6.45526 18.9886 5.62784 17.657 5.62784C16.3111 5.62784 15.331 6.45526 15.3381 7.56676C15.331 8.34801 15.8104 9.01562 16.5312 9.18608V9.22869C15.7038 9.37429 15.0611 10.1449 15.0682 11.0611C15.0611 12.2401 16.13 13.0994 17.657 13.0994ZM17.657 12.201C16.7479 12.201 16.1726 11.718 16.1797 10.9901C16.1726 10.2337 16.7976 9.69389 17.657 9.69389C18.5021 9.69389 19.1271 10.2337 19.1342 10.9901C19.1271 11.718 18.5554 12.201 17.657 12.201ZM17.657 8.81676C16.9219 8.81676 16.3999 8.35156 16.407 7.65909C16.3999 6.97727 16.9041 6.52628 17.657 6.52628C18.3956 6.52628 18.8999 6.97727 18.907 7.65909C18.8999 8.35156 18.3814 8.81676 17.657 8.81676Z",
    fill: "#FFEBE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    stroke: "white",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotifBellPl, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notif-bell-pl.3ec49e0d.svg";
export { ForwardRef as ReactComponent };